import {
  Alert,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { Dispatch, FC, SetStateAction, useContext, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { authContext } from '@staffedupusa/shared-components';
import SurveySingleCard from './SurveryDeatils';
import { staticFileLocation } from '@server/constants';
import VeteranSurveyForm from './VeteranSurveyFormsModal';
import TanfSurveyFormsModal from './TanfSurveyFormsModal';
import UnemploymentFormModal from './UnemploymentFormModal';
import VocationalFormModal from './VocationalFormModal';
import SsiFormModal from './SsiFormModal';
import ExFelonFormModal from './ExFelonFormModal';
import SnapRecipientFormModal from './SnapRecipientFormModal';
import { useGetWotcSurvey } from '@features/wotc/hooks/useGetWotcSurvey';
import GeneralInfoModal from './GenralInfoModal';
import WotcVerificationModal from './WotcVerificationModal';

type WotcSurveyProps = {
  showWotcSurveyModal: boolean;
  setCongratulationsModal?: Dispatch<SetStateAction<boolean>>;
  notificationId?: number;
  handleClose: () => void;
};

const WotcSurvey: FC<WotcSurveyProps> = ({
  showWotcSurveyModal,
  notificationId,
  setCongratulationsModal,
  handleClose,
}) => {
  const { authData } = useContext(authContext);
  const [errorText, setErrorText] = useState('');
  const { wotcSurveyData, isLoadingWotcSurveyData } = useGetWotcSurvey({
    setErrorText,
  });
  const [veteranFormModal, setVeteranModal] = useState(false);
  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const [generalInfoModal, setGeneralInfoModal] = useState(false);
  const [snapRecipientFormModal, setSnapRecipientFormModal] = useState(false);
  const [tanfRecipientFormModal, setTanfRecipientFormModal] = useState(false);
  const [exFelonFormModal, setExFelonFormModal] = useState(false);
  const [longTermUnEmployedFormModal, setLongTermUnEmployedFormModal] =
    useState(false);
  const [
    vocationalRehabilitationFormModal,
    setVocationalRehabilitationFormModal,
  ] = useState(false);
  const [ssiFormModal, setSsiFormModal] = useState(false);

  const wotcDetailsData = [
    {
      id: 1,
      icon: `${staticFileLocation}img/images/icon1.png`,
      isActive: Boolean(wotcSurveyData?.armed_complete),
      title: 'Veteran',
      description:
        " I'm a veteran & I was unemployed for a period totaling at least 6 months during the past year.",
      action: () => setVeteranModal(true),
    },
    {
      id: 2,
      icon: `${staticFileLocation}img/images/icon3.png`,
      title: 'SNAP recipient',
      isActive: Boolean(wotcSurveyData?.snap_complete),
      description:
        "I'm at least age 18 but not over 40, & I am a member of a family that: a. Received SNAP benefits (food stamps) for the past 6 months b. Received SNAP benefits (food stamps) for at least 3 of the past 5 months, but is no longer eligible to receive them.",
      action: () => setSnapRecipientFormModal(true),
    },
    {
      id: 3,
      icon: `${staticFileLocation}img/images/icon4.png`,
      title: 'TANF recipient',
      isActive: Boolean(wotcSurveyData?.tanf_complete),
      description:
        "I'm a member of a family that has received assistance from Temporary Assistance for Needy Families (TANF) for any 9 months during the past 18.",
      action: () => setTanfRecipientFormModal(true),
    },
    {
      id: 4,
      icon: `${staticFileLocation}img/images/icon5.png`,
      title: 'EX-Felon',
      isActive: Boolean(wotcSurveyData?.criminal_complete),
      description:
        'During the past year, I was convicted of a felony or released from prison for a felony.',
      action: () => setExFelonFormModal(true),
    },
    {
      id: 5,
      icon: `${staticFileLocation}img/images/icon6.png`,
      title: 'Long-Term Unemployed',
      isActive: Boolean(wotcSurveyData?.unemployment_complete),
      description:
        'I am currently unemployed & have been for at least 27 consecutive weeks & received unemployment compensation during all or part of that time.',
      action: () => setLongTermUnEmployedFormModal(true),
    },
    {
      id: 7,
      icon: `${staticFileLocation}img/images/icon8.png`,
      title: 'Vocational rehabilitation',
      isActive: Boolean(wotcSurveyData?.certification_complete),
      description:
        'I was referred here by a rehabilitation agency approved by the state, an employment network under the Ticket to Work program, or the Department of Veterans Affairs.',
      action: () => setVocationalRehabilitationFormModal(true),
    },
    {
      id: 7,
      icon: `${staticFileLocation}img/images/icon9.png`,
      title: 'Supplemental security income (SSI)',
      isActive: Boolean(wotcSurveyData?.ssi_complete),
      description:
        'I received supplemental security income (SSI) benefits for any month ending during the past 60 days.',
      action: () => setSsiFormModal(true),
    },
  ];

  return (
    <>
      <Dialog
        open={showWotcSurveyModal}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        disableEnforceFocus
      >
        <DialogTitle>
          <IconButton
            sx={{ position: 'absolute', top: 5, right: 5 }}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
          <br />
          <Typography variant="h4" sx={{ p: 1 }}>
            Please select any category that may apply to you
          </Typography>
          <Typography variant="h6" sx={{ p: 1 }}>
            (You may select more than one or none at all)
          </Typography>
        </DialogTitle>
        <DialogContent>
          {errorText && (
            <Alert sx={{ mb: 1 }} severity="error">
              {errorText}
            </Alert>
          )}
          <Grid container spacing={3}>
            {wotcDetailsData.map((item, index) => (
              <Grid item xs={12} sm={6} md={6} key={index}>
                <SurveySingleCard item={item} />
              </Grid>
            ))}
          </Grid>
          <Button
            onClick={() => setGeneralInfoModal(true)}
            sx={{ mt: 5, mb: 3, width: '100%' }}
            variant="contained"
          >
            Next
          </Button>
        </DialogContent>
      </Dialog>
      {veteranFormModal ? (
        <VeteranSurveyForm
          veteranFormModal={veteranFormModal}
          wotcSurveyData={wotcSurveyData}
          handleClose={() => setVeteranModal(false)}
        />
      ) : null}
      {snapRecipientFormModal ? (
        <SnapRecipientFormModal
          snapRecipientFormModal={snapRecipientFormModal}
          handleClose={() => setSnapRecipientFormModal(false)}
          wotcSurveyData={wotcSurveyData}
        />
      ) : null}
      {tanfRecipientFormModal ? (
        <TanfSurveyFormsModal
          tanfRecipientFormModal={tanfRecipientFormModal}
          handleClose={() => setTanfRecipientFormModal(false)}
          wotcSurveyData={wotcSurveyData}
        />
      ) : null}
      {exFelonFormModal ? (
        <ExFelonFormModal
          exFelonFormModal={exFelonFormModal}
          handleClose={() => setExFelonFormModal(false)}
          wotcSurveyData={wotcSurveyData}
        />
      ) : null}
      {longTermUnEmployedFormModal ? (
        <UnemploymentFormModal
          longTermUnEmployedFormModal={longTermUnEmployedFormModal}
          handleClose={() => setLongTermUnEmployedFormModal(false)}
          wotcSurveyData={wotcSurveyData}
        />
      ) : null}

      {vocationalRehabilitationFormModal ? (
        <VocationalFormModal
          vocationalRehabilitationFormModal={vocationalRehabilitationFormModal}
          handleClose={() => setVocationalRehabilitationFormModal(false)}
          wotcSurveyData={wotcSurveyData}
        />
      ) : null}
      {ssiFormModal ? (
        <SsiFormModal
          ssiFormModal={ssiFormModal}
          wotcSurveyData={wotcSurveyData}
          handleClose={() => setSsiFormModal(false)}
        />
      ) : null}
      {generalInfoModal ? (
        <GeneralInfoModal
          generalInfoModal={generalInfoModal}
          wotcSurveyData={wotcSurveyData}
          handleClose={() => setGeneralInfoModal(false)}
          handleNext={() => setShowVerificationModal(true)}
        />
      ) : null}
      {showVerificationModal ? (
        <WotcVerificationModal
          generalInfoModal={showVerificationModal}
          wotcSurveyData={wotcSurveyData}
          handleClose={() => setShowVerificationModal(false)}
          handleNext={() => {
            setGeneralInfoModal(false);
            setShowVerificationModal(false);
            setCongratulationsModal && setCongratulationsModal(true);
            handleClose();
          }}
          handleBack={() => {
            setGeneralInfoModal(true);
            setShowVerificationModal(false);
          }}
          notificationId={notificationId}
        />
      ) : null}
    </>
  );
};

export default WotcSurvey;
